import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_2 = { class: "ml-2 text-primary" }
const _hoisted_3 = {
  key: 0,
  class: "ml-2 color_error pr-2"
}

import {computed, reactive, ref, shallowRef, watch} from "vue";
import {Task, Order, getGroupFromName, Groups, isStartable, State} from "@/types/Order";
import ConfirmPopUp from "@/components/misc/ConfirmPopUp.vue";
import {VForm} from "vuetify/components";
import TaskInformationDialog from "@/components/dialogs/TaskInformationDialog.vue";
import {useGlobalSetting} from "@/lib/utils";

interface AufgabenTab {
  icon: string;
  text: string;
  value: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TaskPanels',
  props: /*@__PURE__*/_mergeModels({
  readonly: {
    type: Boolean,
    default: false,
  }
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["updateChangeList", "updateDeletedList"], ["update:modelValue"]),
  setup(__props, { expose: __expose, emit: __emit }) {


const selectedID = ref<number>(-1);
const confirmDialog = ref<boolean>(false);
const currentAufgabenTab = shallowRef<string>('tab-1')

const formRefs = ref<InstanceType<typeof VForm>[]>([]);

const globalSettings = useGlobalSetting();

const aufgabenTabs: AufgabenTab[] = [
  {
    icon: 'mdi mdi-information-slab-box',
    text: 'Aufgabe',
    value: 'tab-1'
  },
  {
    icon: 'mdi mdi-reply',
    text: 'Rückmeldung',
    value: 'tab-2'
  }
]

/*const props = defineProps<{
  dataSet: Auftrag
}>();*/

const record = _useModel<Order>(__props, "modelValue");



const panels = reactive<Task[]>(record.value.tasks);

const emit = __emit

const addAufgabe = () => {
  const p = reactive<Task>({
    id: record.value.tasks.length + 1,
    order_id: record.value.id,
    title: "",
    description: "",
    author: "",
    assignee: null,
    work_group: record.value.workGroup,
    state: State.anfo,
    priority: "3",
    sequence: record.value.tasks.length + 1,
    is_lockout: false,
    asset_id: null,
    outage_code: null,
    scheduled_start: null,
    scheduled_end: null,
    scheduled_duration: null,
    feedbacks: [],
  });
  panels.push(p);
  addWatcher(p);
};

const tryRemove = (id: number) => {
  selectedID.value = id;
  confirmDialog.value = true;
}

const removeFeedback = () => {
  const index = panels.findIndex(p => p.id == selectedID.value);
  emit("updateDeletedList", panels[index]);
  panels.splice(index, 1);
  confirmDialog.value = false;
};

const addWatcher = (panel: Task): void => {
  watch(panel, (p) => {
    emit('updateChangeList', panel);
  })
}

panels.forEach(panel => {
  addWatcher(panel)
})

function isHighlighted(aufgabe: Task): boolean {
  const perm = getGroupFromName(aufgabe.work_group).permission;
  if (globalSettings.currentGroup.permission < perm) {
    return true;
  } else if (globalSettings.currentGroup.permission == perm) {
    return globalSettings.currentGroup.name != getGroupFromName(aufgabe.work_group).name;
  } else if (globalSettings.currentGroup.permission > perm) {
    return false;
  } else {
    return true;
  }
}

const isReadonly = computed(() => {
  return globalSettings.currentGroup.permission < Groups.meister.permission;
});

function validateForm() {
  if (!formRefs.value.length) return Promise.resolve(false)
  Promise.all(formRefs.value.map(f => f.validate())).then((result) => {
    return result.every(r => r.valid);
  })
}

__expose({validateForm});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ConfirmPopUp, {
      dialogOpen: confirmDialog.value,
      text: `Bist du sicher, dass du Aufgabe #${selectedID.value} löschen willst?`,
      "cancel-text": "Nein",
      "confirm-text": "Ja",
      title: "Sicher?",
      onConfirm: removeFeedback,
      "onUpdate:dialogOpen": _cache[0] || (_cache[0] = (value) => confirmDialog.value = value)
    }, null, 8, ["dialogOpen", "text"]),
    _createVNode(_component_v_container, {
      class: "pa-0",
      fluid: ""
    }, {
      default: _withCtx(() => [
        (!__props.readonly)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              onClick: addAufgabe
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { start: "" }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("mdi-plus")
                  ])),
                  _: 1,
                  __: [1]
                }),
                _cache[2] || (_cache[2] = _createTextVNode(" Hinzufügen "))
              ]),
              _: 1,
              __: [2]
            }))
          : _createCommentVNode("", true),
        (!__props.readonly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true),
        _createVNode(_component_v_expansion_panels, { variant: "popout" }, {
          default: _withCtx(() => [
            _createVNode(_TransitionGroup, { name: "fade-feedback" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(panels, (panel, index) => {
                  return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                    key: index,
                    style: _normalizeStyle(`border-left: 4px solid ${_unref(getGroupFromName)(panel.work_group).colorcode};`)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panel_title, { class: "d-flex" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { class: "pa-2" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, "Aufgabe " + _toDisplayString(index + 1), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_row, { class: "pa-0" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_2, " Status: " + _toDisplayString(panel.state), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_spacer),
                          (!_unref(isStartable)(record.value, panel.id))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Vorherige Aufgabe ist nicht beendet!"))
                            : _createCommentVNode("", true),
                          (!__props.readonly)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 1,
                                disabled: __props.readonly,
                                color: "red",
                                variant: "plain",
                                onClick: _withModifiers(($event: any) => (tryRemove(panel.id)), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                                      _createTextVNode("mdi-delete")
                                    ])),
                                    _: 1,
                                    __: [3]
                                  })
                                ]),
                                _: 2
                              }, 1032, ["disabled", "onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_expansion_panel_text, null, {
                        default: _withCtx(() => [
                          (record.value.tasks[index])
                            ? (_openBlock(), _createBlock(TaskInformationDialog, {
                                key: 0,
                                modelValue: record.value.tasks[index],
                                "onUpdate:modelValue": ($event: any) => ((record.value.tasks[index]) = $event),
                                readonly: isReadonly.value
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["style"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})